var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card card-default"},[_c('div',{staticClass:"card-body"},[_c('i',{staticClass:"fa fa-btn fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.__("Loading"))+"\n            ")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }